<template>
    <div class="exchange-pieces-success">
        <BaseDialog class="exchange-pieces-success-dialog" v-on="$listeners">
            <div slot="title" class="exchange-pieces-head">
                <p>创建成功</p>
                <img class="exchange-pieces-head-img" src="https://oss01.dayou.art/interior-subscribe-img-head.png" alt="大有预约">
            </div>

            <div slot="content" class="success-content">
                <div class="flex success-content-head">
                    <p class="content-head-title">交换单链接：{{ url }}</p>
                    <div class="common-button content-head-btn-copy" @click="handle_copy">复制</div>
                </div>
                <div class="success-content-tips">
                    <p class="success-content-tip success-content-tip1">*请务必将它分享到群里，否则无法达成交换！</p>
                    <p class="success-content-tip">*1小时未达成交换，交换单将自动取消！</p>
                </div>
            </div>
        </BaseDialog>
    </div>
</template>

<script>
import { copy } from '@/utils/utils'
import BaseDialog from '@/components/dialog/baseDialog/baseDialog'
export default {
    components: {
        BaseDialog,
    },
    props: {
        url: {
            type: String,
            default: '',
        }
    },
    data () {
        return {}
    },
    methods: {
        // 复制
        handle_copy () {
            copy(this.url)
        },
    },
}
</script>

<style lang="less" scoped>
@import "./exchange_pieces_success.less";
</style>